import { Link, useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 网报吃瓜",
    description: "你访问的页面不存在或已被整理归档，可以返回网报吃瓜首页或进入吃瓜事件库浏览热门话题。",
    keywords: "网报吃瓜,吃瓜事件库",
    canonical: "https://zhongjianshuyuan.cn/",
  });

  return (
    <section className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-24 text-center">
      <span className="font-heading text-6xl font-bold text-primary-200 md:text-8xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这条瓜好像被摘走了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        页面不存在或已经归档整理到别处。你可以回到首页，或者直接去事件库看看今天大家都在追什么。
      </p>
      <p className="mt-2 break-all text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/events"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
        >
          <i className="ri-list-check-2" />
          浏览事件库
        </Link>
      </div>
    </section>
  );
}